export enum OperatingSystem {
  Windows = "Windows",
  Macintosh = "Mac_OS",
  Android = "Android",
  iPhone = "iOS",
  Linux = "Linux",
}
export enum Browser {
  Opera = "Opera",
  Chrome = "Chrome",
  Firefox = "Firefox",
  MSIE = "Internet Explorer",
  "rv:" = "IE",
  Safari = "Safari",
  OPR = "Opr",
}

export const detectFromUserAgent = (enumObject: any) => {
  const userAgent = navigator?.userAgent;
  const detectedEntry = Object.entries(enumObject).find(([key]) => userAgent?.includes(key));
  return detectedEntry ? detectedEntry[1] : null;
};

export function getOsAndBrowser() {
  const detectedBrowser = detectFromUserAgent(Browser);
  const detectedOS = detectFromUserAgent(OperatingSystem);

  return {
    ...(detectedOS ? { os: detectedOS } : {}),
    ...(detectedBrowser ? { browser: detectedBrowser } : {}),
  };
}
